(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tac-product-care-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('shopify:block:select', event => {
    if (!window.Shopify?.designMode) return;
    const item = event.target.closest?.('.tac-cf__faq-item');
    const panel = item?.closest('details[data-tac-cf-panel]');
    if (panel) panel.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tac-product-purchase"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tac-product-purchase-v2-3')) return;
  const key = value => String(value ?? '').trim().toLowerCase();
  class TACProductPurchase extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.ready) return;
        try { this.initialize(); } catch (error) { console.error('TAC purchase initialization:', error); }
      });
    }
    disconnectedCallback() {
      this.pauseVideos(); this.events?.abort(); this.resizeObserver?.disconnect(); this.visibilityObserver?.disconnect(); this.pairResizeObserver?.disconnect(); this.upsellObserver?.disconnect();
      if (this.onMediaChange) this.mobileQuery?.removeEventListener('change', this.onMediaChange);
      cancelAnimationFrame(this.scrollFrame); this.scrollFrame = 0; this.ready = false;
    }
    initialize() {
      this.data = JSON.parse(this.querySelector('[data-tac-data]').textContent);
      this.variants = this.data.variants;
      if (!this.variants.length) return;
      this.colorIndex = this.data.colorIndex;
      this.viewport = this.querySelector('[data-tac-viewport]');
      this.gallery = this.querySelector('[data-tac-gallery]');
      this.counter = this.querySelector('[data-tac-counter]');
      this.variantField = this.querySelector('[data-tac-variant]');
      this.quantity = this.querySelector('[data-tac-quantity]');
      this.cartButton = this.querySelector('[data-tac-cart]');
      this.status = this.querySelector('[data-tac-status]');
      this.accelerated = this.querySelector('[data-tac-accelerated]');
      this.price = this.querySelector('[data-tac-price]');
      this.compare = this.querySelector('[data-tac-compare]');
      this.saving = this.querySelector('[data-tac-saving]');
      this.imageBadge = this.querySelector('[data-tac-image-discount]');
      this.galleryNav = this.querySelector('[data-tac-gallery-nav]');
      this.pair = this.querySelector('[data-tac-pair]');
      this.pairLoaded = false; this.boundPairGrid = null;
      this.sizeDialog = this.querySelector('[data-tac-size-dialog]');
      this.videoTemplates = new Map(Array.from(this.querySelectorAll('template[data-tac-video]')).map(t => [t.dataset.tacVideo, t]));
      this.optionButtons = Array.from(this.querySelectorAll('[data-tac-option]'));
      this.mobileQuery = matchMedia('(max-width: 749px)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.viewport.addEventListener('play', event => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        this.viewport.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
      }, { capture: true, signal: this.events.signal });
      this.buildGroups();
      const initial = this.variants.find(v => v.id === this.data.initialVariantId) || this.variants.find(v => v.available) || this.variants[0];
      this.selection = initial.options.slice();
      this.onMediaChange = () => { this.sizeGallery(); this.viewport.scrollTo({ top: 0, left: 0, behavior: 'instant' }); this.updateCounter(); };
      this.mobileQuery.addEventListener('change', this.onMediaChange);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-tac-option]');
        if (button && this.contains(button) && !button.disabled) this.selectOption(Number(button.dataset.tacOption), button.dataset.tacValue);
        const galleryButton = event.target.closest('[data-tac-gallery-step]');
        if (galleryButton && this.contains(galleryButton)) this.goToImage(this.currentImage + Number(galleryButton.dataset.tacGalleryStep));
        const pairButton = event.target.closest('[data-tac-pair-step]');
        if (pairButton && this.contains(pairButton)) {
          const grid = this.pair.querySelector('[data-tac-pair-grid]');
          grid.scrollBy({ left: Number(pairButton.dataset.tacPairStep) * grid.clientWidth, behavior: this.scrollBehavior() });
        }
        if (event.target.closest('[data-tac-size-open]')) this.sizeDialog?.showModal();
        if (event.target.closest('[data-tac-size-close]')) this.sizeDialog?.close();
        const reviewLink = event.target.closest('[data-tac-review-link]');
        if (reviewLink && reviewLink.hash) {
          const provider = reviewLink.closest('[data-tac-rating-provider]')?.dataset.tacRatingProvider;
          let target = document.getElementById(decodeURIComponent(reviewLink.hash.slice(1)));
          if (provider === 'ryviu') {
            const widget = Array.from(document.querySelectorAll('ryviu-widget')).find(element => element.getAttribute('product_id') === this.dataset.productId);
            const tab = document.querySelector('.review-tab-btn');
            if (tab && widget?.closest('.tab-review')) { tab.click(); target = widget; }
            else if (!target && widget) target = widget;
          }
          if (target) {
            event.preventDefault();
            let parent = target.closest('details');
            while (parent) { parent.open = true; parent = parent.parentElement?.closest('details'); }
            target.scrollIntoView({ behavior: this.scrollBehavior(), block: 'start' });
          }
        }
        const stepButton = event.target.closest('[data-tac-quantity-step]');
        if (stepButton && this.contains(stepButton)) {
          this.quantity.value = this.clampQuantity(Number(this.quantity.value) + Number(stepButton.dataset.tacQuantityStep) * Number(this.quantity.step || 1));
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, options);
      this.quantity.addEventListener('change', () => { this.quantity.value = this.clampQuantity(Number(this.quantity.value)); }, options);
      this.querySelector('.tac-pp__form').addEventListener('submit', event => {
        if (!this.variant?.available) { event.preventDefault(); this.status.textContent = 'This selection is unavailable.'; return; }
        this.quantity.value = this.clampQuantity(Number(this.quantity.value));
      }, options);
      this.viewport.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.updateCounter(); });
      }, { passive: true, signal: this.events.signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        const forward = this.mobileQuery.matches ? event.key === 'ArrowRight' : event.key === 'ArrowDown';
        const backward = this.mobileQuery.matches ? event.key === 'ArrowLeft' : event.key === 'ArrowUp';
        if (!forward && !backward) return;
        event.preventDefault(); this.goToImage(this.currentImage + (forward ? 1 : -1));
      }, options);
      this.applyVariant(initial, false);
      this.ready = true; this.classList.add('tac-pp--ready');
      this.resizeObserver = new ResizeObserver(() => { this.sizeGallery(); this.updateCounter(); });
      this.resizeObserver.observe(this.gallery);
      const infoColumn = this.querySelector('.tac-pp__info');
      if (infoColumn) this.resizeObserver.observe(infoColumn);
      window.addEventListener('popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = this.variants.find(v => v.id === id);
        if (variant) { this.selection = variant.options.slice(); this.applyVariant(variant, false); }
      }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseVideos(); }, options);
      this.visibilityObserver = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) this.pauseVideos();
      });
      this.visibilityObserver.observe(this.gallery);
      if (this.pair) {
        try { this.setupUpsellSlot(); }
        catch (error) { if (this.data.designMode) console.info('TAC: original upsell widget unavailable.', error); }
        this.setupPairGrid(); this.updatePairVisibility(); this.loadRecommendations();
      }
      if (window.Shopify?.PaymentButton?.init) {
        try { window.Shopify.PaymentButton.init(); }
        catch (error) { if (this.data.designMode) console.info('TAC: payment button initialization deferred.', error); }
      }
    }
    buildGroups() {
      const images = this.data.media.filter(media => media.type === 'image');
      this.videos = this.data.media.filter(media => media.type === 'video' || media.type === 'external_video');
      this.groups = new Map(); this.mediaById = new Map(images.map(m => [m.id, m]));
      if (this.colorIndex < 0) { this.groups.set('__all', images.slice()); return; }
      const colors = [...new Set(this.variants.map(v => key(v.options[this.colorIndex])))];
      const owners = new Map();
      this.variants.forEach(v => {
        if (!this.mediaById.has(v.mediaId)) return;
        if (!owners.has(v.mediaId)) owners.set(v.mediaId, new Set());
        owners.get(v.mediaId).add(key(v.options[this.colorIndex]));
      });
      const starts = colors.map(color => {
        const index = images.findIndex(m => owners.get(m.id)?.size === 1 && owners.get(m.id).has(color));
        return { color, index };
      }).filter(item => item.index >= 0).sort((a, b) => a.index - b.index);
      this.groupingComplete = starts.length === colors.length;
      if (this.groupingComplete) {
        starts.forEach((start, i) => this.groups.set(start.color, images.slice(start.index, starts[i + 1]?.index ?? images.length)));
      } else {
        colors.forEach(color => {
          const ids = new Set(this.variants.filter(v => key(v.options[this.colorIndex]) === color).map(v => v.mediaId));
          this.groups.set(color, images.filter(m => ids.has(m.id) && owners.get(m.id)?.size === 1));
        });
        const note = this.querySelector('[data-tac-editor-note]');
        if (note) { note.hidden = false; note.textContent = '有颜色缺少独立关联主图，当前仅显示能明确归属的图片。请在商品后台关联各颜色主图，并按颜色连续排列媒体。'; }
      }
      this.optionButtons.filter(b => Number(b.dataset.tacOption) === this.colorIndex).forEach(button => {
        const image = this.groups.get(key(button.dataset.tacValue))?.[0];
        const thumb = button.querySelector('[data-tac-thumb]');
        if (image && thumb) { thumb.src = image.thumb; thumb.hidden = false; }
      });
    }
    matches(variant, selection) { return variant.options.every((value, i) => key(value) === key(selection[i])); }
    selectOption(index, value) {
      const next = this.selection.slice(); next[index] = value;
      let variant = this.variants.find(v => this.matches(v, next));
      let changedSize = false;
      if (!variant && index === this.colorIndex) {
        const candidates = this.variants.filter(v => key(v.options[index]) === key(value));
        const score = v => v.options.reduce((n, option, i) => n + (i !== index && key(option) === key(next[i]) ? 1 : 0), 0);
        candidates.sort((a, b) => Number(b.available) - Number(a.available) || score(b) - score(a));
        variant = candidates[0];
        if (variant) { next.splice(0, next.length, ...variant.options); changedSize = true; }
      }
      this.selection = next;
      this.applyVariant(variant || null, true);
      if (changedSize) this.status.textContent = 'Options updated to an existing variant in this color.';
    }
    applyVariant(variant, updateUrl) {
      this.variant = variant;
      if (variant) this.selection = variant.options.slice();
      this.variantField.value = variant?.id || '';
      this.variantField.dispatchEvent(new Event('change', { bubbles: true }));
      this.price.textContent = variant ? this.decodeMoney(variant.priceText) : 'Unavailable';
      const percent = variant && variant.compare > variant.price ? Math.round((variant.compare - variant.price) * 100 / variant.compare) : 0;
      this.compare.hidden = !percent; this.saving.hidden = !percent; this.imageBadge.hidden = !percent;
      this.compare.textContent = variant ? this.decodeMoney(variant.compareText) : '';
      this.saving.textContent = 'Save ' + percent + '%'; this.imageBadge.textContent = '-' + percent + '%';
      this.cartButton.disabled = !variant?.available;
      this.cartButton.textContent = !variant ? 'UNAVAILABLE' : variant.available ? 'ADD TO CART' : 'SOLD OUT';
      if (this.accelerated) this.accelerated.hidden = !variant?.available;
      this.quantity.min = String(variant?.min || 1); this.quantity.step = String(variant?.step || 1);
      if (variant?.max != null) this.quantity.max = String(variant.max); else this.quantity.removeAttribute('max');
      this.quantity.value = this.clampQuantity(Number(this.quantity.value));
      this.status.textContent = variant?.available ? '' : variant ? 'This variant is sold out.' : 'This combination is unavailable.';
      this.querySelectorAll('[data-tac-selected]').forEach(label => { label.textContent = this.selection[Number(label.dataset.tacSelected)] || ''; });
      this.optionButtons.forEach(button => {
        const index = Number(button.dataset.tacOption), value = button.dataset.tacValue;
        button.setAttribute('aria-pressed', String(key(this.selection[index]) === key(value)));
        const proposed = this.selection.slice(); proposed[index] = value;
        const candidates = index === this.colorIndex ? this.variants.filter(v => key(v.options[index]) === key(value)) : this.variants.filter(v => this.matches(v, proposed));
        button.disabled = !candidates.length;
        button.classList.toggle('is-sold-out', !!candidates.length && !candidates.some(v => v.available));
      });
      const color = this.colorIndex < 0 ? '__all' : key(this.selection[this.colorIndex]);
      const group = (this.groups.get(color) || []).slice();
      const heroIndex = variant ? group.findIndex(m => m.id === variant.mediaId) : -1;
      if (heroIndex > 0) group.unshift(...group.splice(heroIndex, 1));
      const videos = this.videos.filter(media => {
        const tag = media.alt.match(/\[color:\s*([^\]]+)\]/i);
        return !tag || this.colorIndex < 0 || key(tag[1]) === color;
      });
      group.push(...videos.filter(video => !group.some(media => media.id === video.id)));
      this.renderGallery(group, color);
      if (updateUrl && variant && this.data.updateUrl && !this.data.designMode && window.location.pathname.includes('/products/')) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState(window.history.state, '', url);
      }
    }
    decodeMoney(text) { const textarea = document.createElement('textarea'); textarea.innerHTML = text || ''; return textarea.value; }
    clampQuantity(value) {
      const min = Number(this.quantity.min) || 1, step = Number(this.quantity.step) || 1;
      const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
      const highest = Number.isFinite(max) ? min + Math.max(0, Math.floor((max - min) / step)) * step : Infinity;
      const safe = Number.isFinite(value) ? value : min;
      return Math.min(highest, min + Math.max(0, Math.floor((safe - min) / step)) * step);
    }
    renderGallery(items, color) {
      const signature = color + ':' + items.map(m => m.id).join(',');
      if (signature === this.gallerySignature) return;
      this.pauseVideos();
      this.gallerySignature = signature; this.items = items; this.currentImage = 0;
      const fragment = document.createDocumentFragment();
      items.forEach((media, index) => {
        const figure = document.createElement('figure'); figure.className = 'tac-pp__item'; figure.dataset.mediaId = media.id;
        if (media.type === 'image') {
          const image = document.createElement('img'); image.className = 'tac-pp__image'; image.src = media.src; image.alt = media.alt || '';
          image.width = media.width; image.height = media.height; image.loading = index < 2 ? 'eager' : 'lazy'; image.decoding = 'async';
          image.srcset = [400, 600, 900, 1200, 1800, 2400].map(width => {
            const url = new URL(media.src, window.location.href); url.searchParams.set('width', width); return url.href + ' ' + width + 'w';
          }).join(', ');
          image.sizes = '(max-width: 749px) 100vw, 56vw';
          figure.append(image);
        } else {
          figure.classList.add('tac-pp__item--video');
          figure.style.setProperty('--tac-media-ratio', String(media.width / media.height || 3 / 4));
          const template = this.videoTemplates.get(media.id);
          if (template) figure.append(template.content.cloneNode(true));
        }
        fragment.append(figure);
      });
      if (!items.length) { const message = document.createElement('div'); message.className = 'tac-pp__no-images'; message.textContent = 'Images unavailable'; fragment.append(message); }
      this.viewport.replaceChildren(fragment);
      this.viewport.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      this.counter.hidden = items.length < 2;
      this.galleryNav.hidden = items.length < 2;
      this.sizeGallery(); this.updateCounter();
    }
    sizeGallery() {
      const width = this.gallery.getBoundingClientRect().width;
      if (!width) return;
      const first = this.items?.[0]; const natural = first ? width * first.height / first.width : width * 4 / 3;
      const infoHeight = !this.mobileQuery.matches && this.data.alignGalleryBottom
        ? this.querySelector('.tac-pp__info')?.getBoundingClientRect().height || 0 : 0;
      const height = this.mobileQuery.matches ? natural : infoHeight > 0 ? infoHeight : this.data.desktopHeight > 0 ? this.data.desktopHeight : natural * (1 + (this.items?.length > 1 ? this.data.desktopPeek : 0) / 100) + (this.items?.length > 1 ? this.data.imageGap : 0);
      const value = Math.round(height) + 'px';
      if (this.gallery.style.getPropertyValue('--tac-window-height') !== value) this.gallery.style.setProperty('--tac-window-height', value);
    }
    updateCounter() {
      const figures = Array.from(this.viewport.querySelectorAll('.tac-pp__item'));
      const box = this.viewport.getBoundingClientRect();
      let best = 0, bestArea = -1;
      figures.forEach((figure, index) => {
        const rect = figure.getBoundingClientRect();
        const visible = this.mobileQuery.matches ? Math.max(0, Math.min(rect.right, box.right) - Math.max(rect.left, box.left)) : Math.max(0, Math.min(rect.bottom, box.bottom) - Math.max(rect.top, box.top));
        if (visible > bestArea) { bestArea = visible; best = index; }
      });
      const extent = this.mobileQuery.matches ? this.viewport.scrollWidth - this.viewport.clientWidth : this.viewport.scrollHeight - this.viewport.clientHeight;
      const offset = this.mobileQuery.matches ? this.viewport.scrollLeft : this.viewport.scrollTop;
      if (figures.length && extent > 1 && offset >= extent - 2) best = figures.length - 1;
      this.currentImage = best;
      const activeVideo = this.items?.[best] && this.items[best].type !== 'image';
      this.gallery.dataset.videoActive = String(!!activeVideo);
      this.galleryNav?.querySelectorAll('[data-tac-gallery-step]').forEach(button => {
        button.disabled = Number(button.dataset.tacGalleryStep) < 0 ? best === 0 : best >= figures.length - 1;
      });
      this.pauseVideos(best);
      const text = (figures.length ? best + 1 : 0) + ' / ' + figures.length;
      if (this.counter.textContent !== text) this.counter.textContent = text;
    }
    scrollBehavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    pauseVideos(activeIndex = -1) {
      this.viewport?.querySelectorAll('.tac-pp__item--video').forEach(figure => {
        if (activeIndex >= 0 && Array.from(this.viewport.children).indexOf(figure) === activeIndex) return;
        figure.querySelectorAll('video').forEach(video => video.pause());
        figure.querySelectorAll('iframe').forEach(frame => {
          const src = new URL(frame.src, window.location.href);
          if (src.hostname === 'www.youtube.com' || src.hostname === 'www.youtube-nocookie.com') frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), src.origin);
          if (src.hostname === 'player.vimeo.com') frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), src.origin);
        });
      });
    }
    setupUpsellSlot() {
      this.upsellSlot = this.querySelector('[data-tac-upsell-slot]');
      if (!this.upsellSlot) return;
      // Reuse an already rendered widget when the theme editor replaces this section.
      // Moving the live host preserves the app's variant and add-to-cart listeners.
      if (!this.upsellSlot.children.length) {
        const existing = Array.from(document.querySelectorAll('div')).find(host => !host.closest('.tac-pp') && host.shadowRoot?.querySelector('[data-container][data-offer-type="product-cross-sell"]'));
        if (existing) this.upsellSlot.appendChild(existing);
      }
      const update = () => {
        if (!this.isConnected) return;
        let visible = false;
        for (const host of this.upsellSlot.children) {
          const root = host.shadowRoot;
          if (!root?.querySelector('[data-container][data-offer-type="product-cross-sell"]')) continue;
          this.styleUpsellCards(host, root);
          if (!host.classList.contains('magic-upsell-display-none') && !host.hidden) visible = true;
        }
        this.hasOriginalUpsell = visible;
        this.updatePairVisibility();
      };
      this.upsellObserver = new MutationObserver(update);
      this.upsellObserver.observe(this.upsellSlot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
      update();
    }
    styleUpsellCards(host, root) {
      if (host.dataset.tacCardsStyled === 'true') return;
      host.dataset.tacCardsStyled = 'true';
      const style = document.createElement('style');
      style.textContent = `
        [hidden] { display: none !important; }
        .mu-container { margin: 0 !important; font-family: var(--tac-font, inherit) !important; color: var(--tac-ink, #25272a); }
        .mu-header { margin-bottom: 20px !important; align-items: center; }
        .mu-title { font-size: 13px !important; font-weight: 700 !important; letter-spacing: .03em; text-transform: uppercase; }
        .mu-arrow { width: 26px !important; height: 26px !important; border-radius: 0 !important; background: transparent !important; }
        .mu-arrow svg { width: 16px !important; }
        .glider { margin-inline: -12px; width: auto !important; overflow-y: hidden; scrollbar-width: none; }
        .glider::-webkit-scrollbar { display: none; }
        .mu-product { display: grid !important; grid-template-columns: minmax(0, 1fr) !important; align-content: start !important; align-items: start !important; gap: 10px !important; padding: 0 12px !important; border: 0 !important; border-radius: 0 !important; background: transparent !important; box-sizing: border-box !important; }
        .glider:not(:has(.glider-track)) > .mu-product { width: 50%; }
        .mu-product-image-wrapper { display: block !important; width: 100% !important; aspect-ratio: 4 / 5; border-radius: 0 !important; background: #f6f5f3; }
        .mu-image { display: block; width: 100% !important; height: 100% !important; max-width: none !important; object-fit: contain; }
        .mu-content { display: grid !important; grid-template-columns: minmax(0, 1fr) auto; gap: 4px 8px; align-items: start; }
        .mu-product-title { font-family: inherit !important; font-size: 12px !important; line-height: 1.35 !important; font-weight: 500 !important; white-space: normal !important; overflow: visible !important; margin: 0 !important; text-decoration: none !important; }
        .mu-price-wrapper { justify-content: flex-end; gap: 3px !important; }
        .mu-regular-price, .mu-compare-price { font-size: 12px !important; line-height: 1.35 !important; font-weight: 400 !important; }
        .tac-upsell-selection { grid-column: 1 / -1; font-size: 12px; line-height: 1.4; color: #777; }
        .mu-variant-select { grid-column: 1 / -1; width: 100% !important; min-width: 0; min-height: 32px; font-size: 12px !important; margin: 6px 0 0 !important; border-radius: 0 !important; }
        .mu-atc { grid-column: 1 / -1 !important; width: 100%; min-height: 34px; border-radius: 0 !important; font-family: inherit; font-size: 12px !important; padding: 7px 12px !important; }
        @media (max-width: 749px) { .glider { margin-inline: -7px; } .mu-product { padding-inline: 7px !important; } .mu-content { grid-template-columns: minmax(0, 1fr); } .mu-price-wrapper { justify-content: flex-start; } }
      `;
      root.appendChild(style);
      const heading = root.querySelector('[data-container] > .mu-header [data-title]');
      if (heading && this.upsellSlot.dataset.heading) heading.textContent = this.upsellSlot.dataset.heading;
      const cards = Array.from(root.querySelectorAll('[data-product]'));
      cards.forEach(card => {
        const image = card.querySelector('[data-image]');
        if (image?.getAttribute('src')) {
          const url = new URL(image.getAttribute('src'), window.location.href);
          if (url.protocol === 'https:' || url.protocol === 'http:') {
            url.searchParams.set('width', '700'); image.src = url.href;
            image.srcset = [350, 700, 1000].map(width => { const src = new URL(url); src.searchParams.set('width', String(width)); return src.href + ' ' + width + 'w'; }).join(', ');
            image.sizes = '(max-width: 749px) 46vw, 22vw';
          }
        }
        const select = card.querySelector('[data-variant-select]');
        if (select) {
          select.setAttribute('aria-label', 'Choose recommended product variant');
          const label = document.createElement('div'); label.className = 'tac-upsell-selection';
          select.parentNode.insertBefore(label, select);
          const update = () => { label.textContent = select.selectedOptions[0]?.textContent?.trim() || ''; };
          select.addEventListener('input', update, { signal: this.events.signal });
          select.addEventListener('change', update, { signal: this.events.signal }); update();
        }
      });
      const arrows = root.querySelector('[data-arrows-wrapper]');
      if (arrows) arrows.hidden = cards.length <= 2;
      const glider = root.querySelector('.glider');
      const size = () => {
        if (!this.isConnected || !glider?.querySelector('.glider-track') || !window.Glider) return;
        const slider = window.Glider(glider);
        slider.setOption({ slidesToShow: 2, slidesToScroll: 2 }, true);
        slider.refresh(true);
      };
      glider?.addEventListener('glider-loaded', size, { signal: this.events.signal });
      requestAnimationFrame(size);
    }
    updatePairVisibility() {
      if (!this.pair) return;
      const hasCards = !!this.pair.querySelector('[data-tac-pair-card]');
      this.pair.hidden = !hasCards || (this.hasOriginalUpsell && this.pair.dataset.manual !== 'true');
    }
    async loadRecommendations() {
      if (!this.pair || this.pair.dataset.manual === 'true' || this.pairLoaded) return;
      this.pairLoaded = true;
      try {
        const url = new URL(this.pair.dataset.url, window.location.href);
        const intents = url.searchParams.get('intent') === 'related' ? ['related'] : ['complementary', 'related'];
        for (const intent of intents) {
          url.searchParams.set('intent', intent);
          const response = await fetch(url.href, { signal: this.events.signal });
          if (!this.isConnected || this.events.signal.aborted) return;
          if (!response.ok) continue;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const grid = html.querySelector('[data-tac-recommendation-grid]');
          if (!grid?.querySelector('[data-tac-pair-card]')) continue;
          this.pair.querySelector('[data-tac-pair-grid]').replaceChildren(...Array.from(grid.children));
          this.updatePairVisibility(); this.setupPairGrid(); break;
        }
      } catch (error) { if (error.name !== 'AbortError' && this.data.designMode) console.info('TAC: no recommendation cards loaded. Set complementary products or select products in the section.', error); }
    }
    setupPairGrid() {
      const grid = this.pair.querySelector('[data-tac-pair-grid]');
      const nav = this.pair.querySelector('[data-tac-pair-nav]');
      const update = () => {
        const extent = grid.scrollWidth - grid.clientWidth;
        nav.hidden = extent < 2;
        nav.querySelector('[data-tac-pair-step="-1"]').disabled = grid.scrollLeft < 2;
        nav.querySelector('[data-tac-pair-step="1"]').disabled = grid.scrollLeft >= extent - 2;
      };
      if (this.boundPairGrid !== grid) {
        this.boundPairGrid = grid; grid.addEventListener('scroll', update, { passive: true, signal: this.events.signal });
        this.pairResizeObserver?.disconnect();
        this.pairResizeObserver = new ResizeObserver(update); this.pairResizeObserver.observe(grid);
      }
      requestAnimationFrame(update);
    }
    goToImage(index) {
      const figures = Array.from(this.viewport.querySelectorAll('.tac-pp__item'));
      const figure = figures[Math.max(0, Math.min(figures.length - 1, index))];
      if (!figure) return;
      const box = this.viewport.getBoundingClientRect(), rect = figure.getBoundingClientRect();
      const behavior = this.scrollBehavior();
      this.viewport.scrollTo(this.mobileQuery.matches ? { left: this.viewport.scrollLeft + rect.left - box.left, behavior } : { top: this.viewport.scrollTop + rect.top - box.top, behavior });
    }
  }
  customElements.define('tac-product-purchase-v2-3', TACProductPurchase);
})();

  } catch(e) { console.error(e); }
})();
})();
